
import { mapState, mapActions, mapGetters } from "vuex";
import ReportPrintOptions from "./report-print-options.vue";
import reportItemWiseSalesTable from "./report-item-wise-sales-table.vue";
import VueHtml2pdf from "vue-html2pdf";
import ReportPrintTitle from "./report-print-title.vue";
import ReportOrdersTable from "./report-orders-table.vue";
import ReportChannelOrderTable from "./report-channel-order-table.vue";
export default {
  components: {
    ReportPrintOptions,
    reportItemWiseSalesTable,
    VueHtml2pdf,
    ReportPrintTitle,
    ReportOrdersTable,
    ReportChannelOrderTable
  },
  data() {
    return {
      menu: false,
      printType: "paper",
      itemsSelected: [],
      loading: false
    };
  },
  computed: {
    ...mapState("report", ["products"]),
    ...mapGetters("report", ["getChannels"])
  },
  methods: {
    ...mapActions("report", ["getOverallSalesReport"]),

    setPrintType(typeOfPrint) {
      this.printType = typeOfPrint;
    },
    hasDownloaded() {
      this.loading = false;
    },
    setSelectedItems(selectedItems) {
      this.itemsSelected = selectedItems;
    },
    async printAction() {
      this.loading = true;
      const $this = this;
      // this.itemWiseReportDom = true;
      // await this.sleep(1000);
      // this.$refs.html2Pdf.generatePdf();
      if (
        this.printType == "kot" &&
        this.itemsSelected.length == 1 &&
        this.itemsSelected[0] == "item-wise-report"
      ) {
        this.kotPrint();
      } else {
        this.itemsSelected.forEach(async (el) => {
          await this.sleep(1000);
          $this.$refs["html2Pdf__" + el][0]?.generatePdf();
        });
      }
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.menu = false;
      }
    },

    kotPrint() {
      this.getOverallSalesReport({ backgroundLoad: true, force: false });
      const $this = this;
      if (this.products?.length) {
        const data = this.products.map((el) => {
          var qty = 0;
          $this.getChannels.forEach((channel) => {
            qty += Number(el[channel]);
          });
          return { name: el.name, qty, price: el.price, total: qty * el.price };
        });
        this.$nuxt.$emit(
          "initiate-print",
          data,
          "report-kot",
          false,
          true,
          false,
          false,
          true,
          [],
          "item-wise-report"
        );
        this.$nuxt.$on("report-print-completed", () => {
          this.$nuxt.$off("report-print-completed");
        });
      } else {
        this.$nuxt.$emit("show-error-toast", "No items found!");
      }
      this.loading = false;
    }
  }
};
